export const TIME_FORMAT = "ddd. MMM DD, YYYY HH:mm";

/**
 * Option codes and their bit position expressed in base10 which is useful when constructing the
 * argument that needs to be sent to the WebApi to submit a plugin request
 * ex. 
 */
export enum OptionCode {
  RATED = 1,
  EARLY = 2,
  "GO BY" = 4,
}

/**
 * Toggles codes and their bit position expressed in base10 which is useful when constructing the
 * argument that needs to be sent to the WebApi to submit a plugin request
 * ex. 
 */
export const ToggleCode = {
  '2': 4,
  'V': 1,
  'L': 2,
}

/**
 * Toggle Categories codes and their bit position expressed in base10 which is useful when constructing the
 * argument that needs to be sent to the WebApi to submit a plugin request
 * ex. 
 */
export enum ToggleDetailsCode {
  MECHANICS = 1,
  "FIRST AID" = 2,
  TOPSIDE = 4,
  CHECKER = 8,
  MACHINE = 16,
  HOLD = 32,
  GEARPERSON = 64,
  DOCK = 128,
}

export const defaultErrorMsg = "The plug-in window has expired for this Shift! You won't be able to submit your changes at this time. This page will refresh with the original plug-in state."